import { useEffect } from 'react'

export default function useEmissorUnico({ visible, emissores, selecionado, onSelecionar }) {
  useEffect(() => {
    if (visible && emissores.length === 1 && !selecionado) onSelecionar(emissores[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, emissores, selecionado])
}
